<template>
  <div class="container">
    <!-- 顶部悬浮客服图标 -->
    <div class="service-float">
      <div class="service-card" @click="openCustomerService">
        <div
          style="
            display: flex;
            flex-direction: column-reverse;
            align-items: center;
          "
        >
          <div class="service-time">
            <i class="el-icon-service"></i>在线客服
          </div>
          <div class="service-time">8至24点</div>
        </div>
      </div>
    </div>

    <div class="image_box">
      <!-- <img
        ref="detailImage"
        :src="goodsCorePicUrl"
        alt=""
        class="detail-image"
      /> -->
      <div v-html="htmlImgTop" class="content detail-image"></div>
    </div>
    <div class="btnPostion">
      <el-button 
        type="primary" 
        @click="handleReceive" 
        class="receive-btn"
      >
        <span class="btn-text">免费领卡，包邮到家</span>
        <span class="btn-shine"></span>
      </el-button>
    </div>

    <!-- 订单提交成功对话框 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="85%"
      center
      :show-close="false"
      custom-class="success-dialog"
    >
      <div class="success-content">
        <div class="success-icon">
          <i class="el-icon-success"></i>
        </div>
        <div class="success-title">订单提交成功！</div>
        <div class="success-message">
          请您点击右侧在线客服，查询运营商审核结果及后续物流售后问题
        </div>
      </div>
    </el-dialog>

    <!-- 底部弹出的表单抽屉 -->  
    <el-drawer
      :visible.sync="drawerVisible"
      direction="btt"
      :show-close="true"
      :before-close="handleCloseDrawer"
      custom-class="form-drawer"
    >
      <div class="drawer-content"  >
        <div class="cotainerForm">
          <el-form
            ref="formData"
            :model="formLabelAlign"
            label-position="left"
            label-width="100px"
            :rules="rules"
          >
            <div class="Blue_seg">
              <div class="solid"></div>
              <p>实名信息</p>
            </div>
            <el-form-item
              label="身份证姓名:"
              :style="{ width: '90%' }"
              prop="idCardName"
            >
              <el-input
                v-model="formLabelAlign.idCardName"
                placeholder="请输入身份证姓名(已加密)"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="身份证号:"
              :style="{ width: '90%' }"
              prop="idCardNo"
            >
              <el-input
                v-model="formLabelAlign.idCardNo"
                placeholder="请输入身份证号(已加密)"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="联系电话:"
              :style="{ width: '90%' }"
              prop="receiverTel"
            >
              <el-input
                v-model="formLabelAlign.receiverTel"
                placeholder="请输入联系电话,并保持畅通"
              ></el-input>
            </el-form-item>
            <div class="Blue_seg">
              <div class="solid"></div>
              <p>填写配送地址</p>
            </div>
            <el-form-item
              label="所在城市:"
              :style="{ width: '90%' }"
              prop="pctIds"
            >
              <el-cascader
                v-model="formLabelAlign.pctIds"
                :options="areaLeaveOption"
                placeholder="省、市、区"
                :props="cascaderProps"
                clearable
                :style="{ width: '100%' }"
                popper-class="mobile-cascader-popper"
                @change="handleCascaderChange"
                @touchstart.native="handleCascaderTouchStart"
                ref="cascaderRef"
              ></el-cascader>
            </el-form-item>
            <el-form-item
              label="详细地址:"
              :style="{ width: '90%' }"
              prop="receiverAddr"
            >
              <el-input
                v-model="formLabelAlign.receiverAddr"
                placeholder="小区、写字楼、门牌号等"
              ></el-input>
            </el-form-item>
            <div class="Blue_seg" v-show="imgShow">
              <div class="solid"></div>
              <p>身份信息</p>
            </div>
            <el-row :gutter="20" v-if="imgShow">
              <el-col :span="8">
                <el-form-item prop="idCardImg01" label-width="0">
                  <ImageUpload
                    v-model="formLabelAlign.idCardImg01"
                    :isShowTip="false"
                  />
                </el-form-item>
                <p :style="{ fontSize: '12px', width: '100%' }">^人像面照片</p>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="idCardImg02" label-width="0">
                  <ImageUpload
                    v-model="formLabelAlign.idCardImg02"
                    :isShowTip="false"
                  />
                </el-form-item>
                <p :style="{ fontSize: '12px', width: '100%' }">
                  ^人国徽面照片
                </p>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="idCardImg03" label-width="0">
                  <ImageUpload
                    v-model="formLabelAlign.idCardImg03"
                    :isShowTip="false"
                  />
                </el-form-item>
                <p :style="{ fontSize: '12px', width: '100%' }">
                  ^手持证件照片
                </p>
              </el-col>
            </el-row>
            <span class="Spanmsg">^请填写真实身份信息，信息错误将无法发货</span>
            <div
              style="margin-top: 20px"
              v-if="goodsId == 1170 || goodsId == 1169"
            >
              <span>
                <el-checkbox v-model="isAgree">我已阅读并同意</el-checkbox>
                <span
                  class="agreement-link"
                  @click="handleAgreementClick('telecomFraud')"
                  >《电信网络诈骗犯罪及发送不良信息法律责任风险提示告知书》</span
                >
                <span
                  class="agreement-link"
                  @click="handleAgreementClick('accountService')"
                  >《电子渠道开户服务协议》</span
                >
                <span
                  class="agreement-link"
                  @click="handleAgreementClick('fiveMinistries')"
                  >《五部委公告》</span
                >
                <span
                  class="agreement-link"
                  @click="handleAgreementClick('campusDiscount')"
                  >《校园客户新入网优惠协议》</span
                >
                <span
                  class="agreement-link"
                  @click="handleAgreementClick('productSales')"
                  >《中国移动广东公司电子渠道商品销售服务协议》</span
                >
                <span
                  class="agreement-link"
                  @click="handleAgreementClick('customerNetwork')"
                  >《中国移动广东公司客户入网协议》</span
                >
                <span
                  class="agreement-link"
                  @click="handleAgreementClick('privacyPolicy')"
                  >《中国移动广东公司隐私和信息保护政策》</span
                >
                <span
                  class="agreement-link"
                  @click="handleAgreementClick('terMination')"
                  >《解约条款》</span
                >
                <span
                  class="agreement-link"
                  @click="handleAgreementClick('antiFraud')"
                  >《反诈宣传通告》</span
                >
              </span>
            </div>
          </el-form>
          <div class="submit-btn-wrapper">
            <el-button
              type="primary"
              @click="submitEvent"
              :style="{ width: '100%' }"
              >立即办理</el-button
            >
          </div>
        </div>
      </div>
      <!-- <div class="boxBig" v-else>
        <div class="box1">
          <el-button
            type="success"
            icon="el-icon-check"
            circle
            :style="{ marginRight: '10px' }"
          ></el-button
          >提交成功！
        </div>
        <div class="box2">
          <el-button @click="goBacksubmit">点我返回提交页面</el-button>
        </div>
      </div> -->
    </el-drawer>
  </div>
</template>  
   <script>
import { getDetailst } from "@/api/productManage/goods/already/index";
import { getareaLevel3, orderNew, getProCityByIp } from "@/api/placeorder";

export default {
  name: "LgTelecomUiPlaceorder",
  data() {
    return {
      htmlImgTop: undefined,
      goodsCorePicUrl: "",
      goodsId: undefined,
      spreadUserId: undefined,
      requireIdCardPic: undefined,
      drawerVisible: true,
      isAgree: false,
      dialogVisible: false,
      formLabelAlign: {
        idCardName: undefined,
        idCardNo: undefined,
        receiverTel: undefined,
        pctIds: undefined,
        receiverAddr: undefined,
        goodsId: undefined,
        spreadUserId: undefined,
        idCardImg01: undefined,
        idCardImg02: undefined,
        idCardImg03: undefined,
        type: "h5",
      },
      rules: {
        idCardName: [
          { required: true, message: "请输入有效身份证姓名", trigger: "blur" },
          {
            pattern: /^[\u4e00-\u9fa5]{0,5}$/,
            message: "请输入有效身份证姓名",
            trigger: "blur",
          },
          { min: 2, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        idCardNo: [
          { required: true, message: "请输入有效身份证号", trigger: "blur" },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入有效身份证号码",
            trigger: "blur",
          },
        ],
        receiverTel: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: "请输入有效的手机号码",
            trigger: "blur",
          },
        ],
        pctIds: [
          {
            required: true,
            message: "请输入有效省、市、区",
            trigger: "change",
          },
        ],
        receiverAddr: [
          { required: true, message: "请选择有效详细地址", trigger: "blur" },
        ],
        idCardImg01: [
          { required: true, message: "请上传身份证人面", trigger: "change" },
        ],
        idCardImg02: [
          { required: true, message: "请上传身份证国徽面", trigger: "change" },
        ],
        idCardImg03: [
          { required: true, message: "请上传手持证件照", trigger: "change" },
        ],
      },
      // 级联选择器配置 - 移动端优化
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        expandTrigger: 'click', // 点击展开
        emitPath: true,
        checkStrictly: false, //
      },
      areaLeaveOption: [],
      imgShow: false
    };
  },  
  created() {
    this.goodsId = this.$route.query.id;
    this.spreadUserId = this.$route.query.spreadUserId;
    this.formLabelAlign.goodsId = this.$route.query.id;
    this.formLabelAlign.spreadUserId = this.$route.query.spreadUserId;
    this.createEdit();
    this.getList();  
  },
  watch: {
    "formLabelAlign.idCardImg01"(newVal) {
      if (newVal !== null && newVal !== undefined && newVal !== "") {
        this.$refs.formData &&
          this.$refs.formData.clearValidate(["idCardImg01"]);
      }
    },
    "formLabelAlign.idCardImg02"(newVal) {
      if (newVal !== null && newVal !== undefined && newVal !== "") {
        this.$refs.formData &&
          this.$refs.formData.clearValidate(["idCardImg02"]);
      }
    },
    "formLabelAlign.idCardImg03"(newVal) {
      if (newVal !== null && newVal !== undefined && newVal !== "") {
        this.$refs.formData &&
          this.$refs.formData.clearValidate(["idCardImg03"]);
      }
    },
  },
  mounted() {
    // 移动端优化：添加触摸事件监听
    this.$nextTick(() => {
      if (this.$refs.cascaderRef) {
        const cascaderEl = this.$refs.cascaderRef.$el;
        const input = cascaderEl.querySelector('.el-input__inner');
        if (input) {
          // 优化触摸响应
          input.style.touchAction = 'manipulation';
          input.style.webkitUserSelect = 'none';
        }
      }
    });
  },
  methods: {
    // 级联选择器值变化处理（移动端优化）
    handleCascaderChange(value) {
      // 选择完成后，清除验证提示
      if (value && value.length === 3) {
        this.$refs.formData && this.$refs.formData.clearValidate(['pctIds']);
      }
    },
    // iOS 移动端触摸优化 - 解决点击两次问题
    handleCascaderTouchStart(event) {
      if (this._isMobile()) {
        console.log('移动端触摸优化启动');
        
        // 在 iOS 设备上特别处理
        if (this._isIOS()) {
          console.log('iOS 设备检测到，使用优化方案');
          // 阻止默认行为，避免双重触发
          event.preventDefault();
          
          // 立即打开下拉面板
          this.$nextTick(() => {
            if (this.$refs.cascaderRef) {
              try {
                // 方法1: 调用 toggleDropDownVisible
                this.$refs.cascaderRef.toggleDropDownVisible(true);
              } catch (e) {
                // 方法2: 如果方法1失败，尝试直接操作
                const input = this.$refs.cascaderRef.$el.querySelector('.el-input__inner');
                if (input) {
                  input.click();
                }
              }
            }
          });
        }
      }
    },
    // 检测是否为 iOS 设备
    _isIOS() {
      const u = navigator.userAgent;
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    },
    // 检测是否为移动设备
    _isMobile() {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
    },
    // 打开客服链接
    openCustomerService() {
      // 在新标签页打开客服链接
      window.open("https://work.weixin.qq.com/kfid/kfc187902d3a3b9df4f", "_blank");
    },
    createEdit() {
      getDetailst(this.$route.query.id).then((res) => {
        if (res.code == 200) {
          const richText = res.data.goodsDetails;
          const parser = new DOMParser();
          const doc = parser.parseFromString(richText, "text/html");
          const img = doc.querySelector("img");
          if (img) {
            const imgUrl = img.getAttribute("src");
            this.goodsCorePicUrl = imgUrl;
          }
          // 保存商品详情HTML
          this.htmlImgTop = res.data.goodsDetails;
          // 保存是否需要身份证照片
          this.requireIdCardPic = res.data.requireIdCardPic;
          this.imgShow = res.data.requireIdCardPic === "1";
        }
      });
    },
    handleReceive() {
      // 打开底部抽屉
      this.drawerVisible = true;
    },
    handleCloseDrawer(done) {
      done();
    },
    split(data) {
      let newData = [];
      data.forEach((item) => {
        let newItem = { ...item };
        if (newItem.children && newItem.children.length === 0) {
          delete newItem.children;
        } else if (newItem.children) {
          newItem.children = this.split(newItem.children);
        }
        newData.push(newItem);
      });
      return newData;
    },
    getList() {
      getareaLevel3().then((res) => {
        if (res.code == 200) {
          this.areaLeaveOption = this.split(res.data);
          // 获取到地址数据后，自动定位IP所在省市
          this.autoFillLocationByIp();
        }
      });
    },
    // 根据IP自动填充省市区
    autoFillLocationByIp() {
      getProCityByIp().then((res) => {
        if (res.code == 200 && res.data) {
          const { provinceName, cityName, districtName } = res.data;
          
          // 如果返回了省市区信息，则进行匹配
          if (provinceName && cityName) {
            const matchedIds = this.findAreaIds(provinceName, cityName, districtName);
            if (matchedIds && matchedIds.length >= 2) {
              // 自动填充到cascader
              this.formLabelAlign.pctIds = matchedIds;
              console.log('自动定位成功:', { provinceName, cityName, districtName, ids: matchedIds });
            }
          }
        }
      }).catch(err => {
        console.log('IP定位失败，使用手动选择:', err);
      });
    },
    // 在地址数据中查找匹配的ID
    findAreaIds(provinceName, cityName, districtName) {
      try {
        // 查找省份
        const province = this.areaLeaveOption.find(item => 
          item.name === provinceName || item.name.includes(provinceName) || provinceName.includes(item.name)
        );
        if (!province) return null;
        
        // 查找城市
        const city = province.children?.find(item => 
          item.name === cityName || item.name.includes(cityName) || cityName.includes(item.name)
        );
        if (!city) return [province.id];
        
        // 查找区县（如果有）
        if (districtName && city.children) {
          const district = city.children.find(item => 
            item.name === districtName || item.name.includes(districtName) || districtName.includes(item.name)
          );
          if (district) {
            return [province.id, city.id, district.id];
          }
        }
        
        // 如果没有区县，返回省市
        return [province.id, city.id];
      } catch (error) {
        console.error('匹配地址ID失败:', error);
        return null;
      }
    },
    submitEvent() {
      if (this.goodsId == 1170 || this.goodsId == 1169) {
        if (!this.isAgree) {
          this.$modal.msgError("请阅读并同意相关协议");
          return;
        }
      }

      this.$refs["formData"].validate((valid) => {
        if (valid) {
          const pctIds = Array.isArray(this.formLabelAlign.pctIds)
            ? this.formLabelAlign.pctIds.join(",")
            : this.formLabelAlign.pctIds;
          const submitData = { ...this.formLabelAlign, pctIds };
          orderNew(submitData).then((res) => {
            if (res.code == 200) {
              // 关闭抽屉并显示成功对话框
              this.drawerVisible = false;
              this.dialogVisible = true;
            }
          });
        } else {
          this.$modal.msgError("请填写完整信息");
        }
        this.$refs.formData.clearValidate();
      });
    },
    // 关闭成功对话框
    handleDialogClose() {
      this.dialogVisible = false;
      this.goBacksubmit();
    },
    // 打开客服
    handleOpenService() {
      this.openCustomerService();
      this.dialogVisible = false;
      this.goBacksubmit();
    },
    goBacksubmit() {
      this.dialogVisible = false;
      this.drawerVisible = false;
      this.isAgree = false;
      this.formLabelAlign = {
        idCardName: undefined,
        idCardNo: undefined,
        receiverTel: undefined,
        pctIds: undefined,
        receiverAddr: undefined,
        goodsId: this.$route.query.id,
        spreadUserId: this.$route.query.spreadUserId,
        idCardImg01: undefined,
        idCardImg02: undefined,
        idCardImg03: undefined,
        type: "h5",
      };
    },
     // 处理协议点击 - 跳转到协议页面
     handleAgreementClick(agreementType) {       
       if (agreementType) {
         this.$router.push({
           path: agreementType
         });
       } else {
         this.$modal.msgWarning('协议页面未配置');
       }
     },
  },
};
</script>
<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f5f5f5;
  position: relative;
  padding: 0;
  padding-bottom: 80px;
  margin: 0;
}

// 悬浮客服图标
.service-float {
  position: fixed;
  top: 50%;
  right: 30px;
  z-index: 9999999999999;

  .service-card {
    background: #1677ff; // 支付宝蓝色
    padding: 8px 8px;
    border-radius: 20px;
    //   box-shadow: 0 2px 12px rgba(22, 119, 255, 0.3);
    display: flex;
    align-items: center;
    gap: 8px;
    box-sizing: border-box;
    cursor: pointer;
    //   transition: all 0.3s ease;
    //   animation: pulse 2s ease-in-out infinite;
    writing-mode: vertical-rl; /* 竖向显示，从右到左 */
    text-orientation: upright; /* 文字保持正向，不旋转 */

    i {
      font-size: 20px;
      color: #fff;
    }

    .service-time {
      font-size: 13px;
      color: #fff;
      font-weight: 500;
      white-space: nowrap;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(22, 119, 255, 0.4);
    }
  }
}

// 脉动动画
@keyframes pulse {
  0%,
  100% {
    box-shadow: 0 2px 12px rgba(22, 119, 255, 0.3);
  }
  50% {
    box-shadow: 0 2px 16px rgba(22, 119, 255, 0.5);
  }
}

.image_box {
  width: 100%;
  background-color: #fff;
  margin: 0;
  padding: 0;

  .detail-image {
    width: 100%;
    display: block;
    // margin-top: -16px;
  }
}

.btnPostion {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 15px 10px;
  display: flex;
  justify-content: center;
  z-index: 100;
  box-sizing: border-box;
  background: linear-gradient(to top, rgba(255,255,255,0.95), rgba(255,255,255,0));
  padding-bottom: 20px;
  // 给整个容器添加呼吸脉冲动画
  animation: containerPulse 2s ease-in-out infinite;
}

// 容器呼吸脉冲动画（变大变小）
@keyframes containerPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
}

// 立即领取按钮样式
.receive-btn {
  width: 95%;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  position: relative;
  overflow: hidden;
  border-radius: 25px;
  border: none;
  background: linear-gradient(135deg, #667eea 0%, #5264c0 100%);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
  transition: transform 0.2s, box-shadow 0.2s;
  
  &:active {
    transform: scale(0.95);
    box-shadow: 0 4px 10px rgba(102, 126, 234, 0.5);
  }
  
  .btn-text {
    position: relative;
    z-index: 2;
    display: inline-block;
    text-align: center;
    line-height: 30px;
  }
  
  // 光泽效果
  .btn-shine {
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
      45deg,
      transparent 30%,
      rgba(255, 255, 255, 0.3) 50%,
      transparent 70%
    );
    transform: rotate(45deg);
    animation: shine 3s ease-in-out infinite;
  }
}

// 光泽扫过效果
@keyframes shine {
  0% {
    left: -100%;
  }
  20% {
    left: 100%;
  }
  100% {
    left: 100%;
  }
}

::v-deep .content {
  width: 100%;
  margin: 0;
  padding: 0;
  
  img {
    width: 100%;
    display: block;
    margin: 0;
    padding: 0;
  }
}

// 抽屉样式
::v-deep .form-drawer {
  border-radius: 20px 20px 0 0;
  height: auto !important;
  max-height: 85vh !important; // 最大高度不超过屏幕的85%

  .el-drawer__header {
    margin-bottom: 10px;
    padding: 15px 20px 10px;
    border-bottom: 1px solid #eee;
  }

  .el-drawer__body {
    padding: 0;
    overflow-y: auto;
    max-height: calc(85vh - 60px); // 减去header的高度
  }
}

.drawer-content {
  min-height: auto;
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
}

.cotainerForm {
  width: 100%;
  padding: 0px 10px 20px;
  flex: 1;
  overflow-y: auto;
  box-sizing: border-box;

  .Blue_seg {
    width: 100%;
    height: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 10px 0;

    .solid {
      width: 3px;
      height: 20px;
      background-color: #3b76fd;
      margin-left: 5px;
    }

    p {
      color: #3b76fd;
      margin-left: 10px;
      font-weight: bold;
    }
  }

  .Spanmsg {
    font-size: 12px;
    color: #666;
  }
}

// 提交按钮容器
.submit-btn-wrapper {
  width: 100%;
  padding: 20px 0;
  margin-top: 10px;
}

// 协议链接样式
.agreement-link {
  color: #3b76fd;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  position: relative;

  &:hover {
    color: #1677ff;
    text-decoration: underline;
  }

  &:active {
    opacity: 0.7;
  }
}

// 成功对话框样式
::v-deep .success-dialog {
  border-radius: 15px;
  
  .el-dialog__header {
    display: none;
  }
  
  .el-dialog__body {
    padding: 30px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.success-content {
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  .success-icon {
    margin-bottom: 25px;
    
    i {
      font-size: 70px;
      color: #67c23a;
    }
  }
  
  .success-title {
    font-size: 22px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 20px;
  }
  
  .success-message {
    font-size: 15px;
    color: #1677ff;
    line-height: 1.8;
    padding: 0 10px;
  }
}

.boxBig {
  width: 100%;
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 20px;

  .box1 {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #67c23a;
  }

  .box2 {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }
}

::v-deep .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 110px;
}

::v-deep .el-upload-list__item {
  width: 100px;
  height: 100px;
}

::v-deep .el-upload-list__item.is-success {
  width: 100px;
  height: 100px;
}

  ::v-deep .el-upload-list__item-thumbnail {
    width: 100px;
    height: 100px;
  }

  // 移动端级联选择器样式优化
  ::v-deep .el-cascader {
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
    
    .el-input__inner {
      -webkit-tap-highlight-color: transparent;
      touch-action: manipulation;
      cursor: pointer;
      font-size: 16px; // 防止iOS自动放大
    }
  }
  </style>

  <!-- 全局样式：级联选择器弹出层优化（不使用 scoped，因为弹出层在 body 下） -->
  <style lang="scss">
  // 级联选择器下拉面板移动端优化
  .el-popper.mobile-cascader-popper {
    -webkit-tap-highlight-color: transparent !important;
    user-select: none !important;
    
    // 控制整体弹出面板的尺寸
    .el-cascader-panel {
      font-size: 11px !important; // 减小字体
      
      .el-cascader-menu {
        min-width: 90px !important; // 进一步减小每列的宽度
        width: 90px !important;
        max-height: 240px !important; // 增加高度显示更多选项
        -webkit-overflow-scrolling: touch;
        
        .el-cascader-menu__wrap {
          max-height: 240px !important; // 限制滚动区域高度
          -webkit-overflow-scrolling: touch;
        }
        
        .el-scrollbar__view {
          padding: 0 !important;
        }
      }
    }
    
    .el-cascader-node {
      -webkit-tap-highlight-color: transparent !important;
      touch-action: manipulation !important;
      user-select: none !important;
      cursor: pointer !important;
      transition: background-color 0.15s !important;
      height: 38px !important; // 保持合适的点击区域
      line-height: 38px !important;
      padding: 0 !important;
      
      &:active {
        background-color: #f5f7fa !important;
      }
      
      // 减小内边距，让内容更紧凑
      .el-cascader-node__label {
        padding: 0 6px !important; // 减小内边距
        font-size: 11px !important; // 减小字体
        line-height: 38px !important;
        height: 38px !important;
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
      }
      
      // 确保箭头图标不干扰点击
      .el-cascader-node__postfix {
        pointer-events: none !important;
        right: 2px !important;
        
        .el-icon-arrow-right {
          font-size: 0px !important; // 减小箭头大小
        }
      }
      
      .el-cascader-node__prefix {
        display: none !important; // 隐藏前缀，节省空间
      }
      
      .el-radio {
        display: none !important; // 隐藏单选框，节省空间
      }
    }
  }
  
  // 移动端媒体查询优化
  @media only screen and (max-width: 768px) {
    ::v-deep .el-popper.mobile-cascader-popper {
      // 移动端进一步优化尺寸
      .el-cascader-panel {
        .el-cascader-menu {
          min-width: 90px !important; // 移动端列宽更小，确保三列能完整显示
          width: 90px !important;  
          max-height: 250px !important;
        }  
      }
      
      .el-cascader-node {
        height: 40px !important; // 移动端增加高度，方便点击
        line-height: 40px !important;
        
        .el-cascader-node__label {
          font-size: 11px !important;
          line-height: 40px !important;
          height: 40px !important;
          padding: 0 5px !important;
        }
      }
    }
  }
</style>

<style lang="scss">
// 解决 Cascader 移动端点击两次问题：让滚动条始终显示，避免滚动条动画干扰点击
.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1 !important;
  }
}

// 针对 mobile-cascader-popper 的额外优化
.mobile-cascader-popper {
  .el-scrollbar {
    > .el-scrollbar__bar {
      opacity: 1 !important;
      
      &.is-vertical {
        right: 0 !important;
        width: 6px !important;
      }
    }
    
    > .el-scrollbar__wrap {
      overflow-x: hidden !important;
    }
  }
  
  // 确保每个选项都能立即响应点击
  .el-cascader-node {
    // 移除可能干扰的过渡动画
    transition: background-color 0.1s !important;
    
    // 确保整个节点区域都可点击
    &__label {
      display: block !important;
      width: 100% !important;
      cursor: pointer !important;
    }
  }
}
</style>
